import React from 'react';
import {isEmpty as _isEmpty} from 'lodash';
import {Popup} from 'semantic-ui-react';

import {EventContentVariantPopup} from '@utils/eventContentVariant/EventContentVariantPopup';
import {INCIDENT_DURATION_UNIT_MINUTE} from '@constants/variables';
import {convertSecondsToMinutesWithOneDecimal, convertToInt, getMinutesAndSeconds} from '@utils/helpers';

export const renderScopes = (scopes) => {
    if (!scopes || _isEmpty(scopes)) {
        return '';
    }

    return (
        <>
            {scopes.map((item, index) => (
                <div key={index}>
                    {item.text} <EventContentVariantPopup eventContentVariant={item.event_content_variant}/>
                </div>
            ))}
        </>
    );
};

export const renderIncidentType = (incidentType) => {
    if (!incidentType?.name) return '';

    return incidentType.description ? (
        <Popup
            trigger={<span>{incidentType.name}</span>}
            content={incidentType.description}
            size='small'
            hoverable
        />
    ) : incidentType.name;
};

export const renderIncidentDuration = (duration, durationUnit) => {
    if (!duration || !durationUnit) return '';

    const isMinuteUnit = durationUnit.id === INCIDENT_DURATION_UNIT_MINUTE;
    const displayValue = isMinuteUnit
        ? convertSecondsToMinutesWithOneDecimal(duration)
        : convertToInt(duration);

    if (!isMinuteUnit) {
        return displayValue + durationUnit.short_name;
    }

    const durationTime = getMinutesAndSeconds(duration/60);
    const popupContent = `${durationTime.minutes} minutes ${durationTime.seconds} seconds`;

    return (
        <Popup
            trigger={<span>{displayValue + durationUnit.short_name}</span>}
            content={popupContent}
            size='small'
            hoverable
        />
    );
};

export const formatMessageWithBold = (message) => {
    if (!message) {
        return null;
    }

    const parts = message.split(/\*(.*?)\*/g);

    return (
        <>
            {parts.map((part, index) => {
                if (1 === index % 2) {
                    return <strong key={index}>{part}</strong>;
                }

                return part;
            })}
        </>
    );
};
